<div *ngIf="steps.length>0" class="flow-progress-v2" [ngClass]="{'flow-progress-v2-extended': steps.length>=2}">
    <span class="flow-progress-v2__text"
         role="text" attr.aria-label="{{'PROGRESS_BAR_TITLE_ARIA_LABEL' | translate}}">{{'PROGRESS_BAR_TITLE' | translate}}</span>
    <ng-container *ngFor="let step of steps; let index = index; let last = last">
        <div class="flow-progress-v2__step"
            [ngClass]="{'flow-progress-v2__step--active': index+1===activeStep, 'flow-progress-v2__step--finished':index+1<activeStep}">
            <span class="flow-progress-v2__number">
                <ng-container *ngIf="index+1>=activeStep">
                   <span role="text" attr.aria-label="{{'BLOCK_STEP_ARIA_LABEL' | translate}} {{index+1}}">{{index+1}}</span>
                </ng-container>
                <span  *ngIf="index+1<activeStep"  class="icon icon--xs icon-progress-check"></span>
                <span *ngIf="index+1==activeStep" class="wcag-hidden hide-desktop hide-tablet show-mobile">{{'PROGRESS_BAR_CURRENT_STEP_ARIA_LABEL' | translate}} {{step | translate}}</span>
                <span *ngIf="index+1<activeStep" class="wcag-hidden hide-desktop hide-tablet show-mobile">{{'PROGRESS_BAR_COMPLETED_STEP_ARIA_LABEL' | translate}} {{step | translate}}</span>
            </span>
            <!-- TODO: NB! check other sites aswell -->
            <span class="flow-progress-v2__step-name">{{step | translate}}</span>
            <span *ngIf="index+1==activeStep" class="flow-progress-v2__step-name wcag-hidden">{{'PROGRESS_BAR_CURRENT_STEP_ARIA_LABEL' | translate}}</span>
            <span *ngIf="index+1<activeStep" class="flow-progress-v2__step-name wcag-hidden">{{'PROGRESS_BAR_COMPLETED_STEP_ARIA_LABEL' | translate}}</span>
        </div>

        <div *ngIf="!last" class="flow-progress-v2__separator "
            [ngClass]="{'flow-progress-v2__separator--passed': index+1<activeStep}"></div>
    </ng-container>
</div>
